import type { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		fill="none"
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			stroke="var(--svg-color, currentColor)"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.5"
			d="m13 5 7 7-7 7"
		></path>
		<path
			fill="var(--svg-color, currentColor)"
			d="M4 11.25a.75.75 0 0 0 0 1.5v-1.5M20 12v-.75H4v1.5h16z"
		></path>
	</svg>
);

export { SvgComponent as Arrow };
